var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 112,
    viewBox: "0 0 69 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.4698,
    cy: 42.0166,
    r: 69.0269,
    transform: "rotate(180 69.4698 42.0166)",
    stroke: "#F1613F",
    strokeWidth: 0.545667
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.556,
    cy: 49.1107,
    r: 55.9309,
    transform: "rotate(180 58.556 49.1107)",
    stroke: "#29C302",
    strokeWidth: 0.545667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRight);
export default __webpack_public_path__ + "static/media/top-right.777174a5534bcaa61e4b83d3096d2a38.svg";
export { ForwardRef as ReactComponent };